<script>
	import Icons from './Icons.svelte';
	import viewport from './useViewportAction';
	import {positionX, positionY, dimensionX, dimensionY} from './store.js'; //* as store //$store.thing
	import Terre from './Terre.svelte';

	// import Banner from './Banner.svelte';
	// import TogglePortfolio from './TogglePortfolio.svelte';

// import Intersect from './Intersect.svelte'
// import IpsumWars from './IpsumWars.svelte';
// import Section from './Section.svelte';

// Region zoom: https://svelte.dev/repl/75d0130acc704eceb7aa78d3e473441c?version=3.24.0
$positionX = 256;// 0 0 1024 1024
$positionY = 256;// 0 0 1024 1024
$dimensionX = 512;// 256 256 512 512
$dimensionY = 512;// 256 256 512 512

function reset() {
	$positionX = 256;// 0 0 1024 1024
	$positionY = 256;// 0 0 1024 1024
	$dimensionX = 512;// 256 256 512 512
	$dimensionY = 512;// 256 256 512 512
}

function set() {
$positionX = 0;// 256;// 0 0 1024 1024
$positionY = 0;// 256;// 0 0 1024 1024
$dimensionX = 1024;// 512;// 256 256 512 512
$dimensionY = 1024;// 512;// 256 256 512 512
}

/*
Tween basics: https://svelte.dev/examples#tweened
*/



let destinations = [
{
zoomPositionX: 192,
zoomPositionY: 256,
zoomDimensionX: 386,
zoomDimensionY: 386,
name: "Vernazza to Monterosso Trail",
titolo: "Il sentiero di Vernazza Monterosso",
class: "hiking",
rating: "Challenging",
distance: "3",
miles: "2",
from: "vernazza",
to: "monterosso",
poi: "Vernazza to Monterosso or vice-versa",
intro: "Due to its narrow winding paths flanked by a drop on one side and steep ascent/descent along an unpaved rocky wavy, the Vernazza-Monterosso hike is one of the toughest hikes in Cinque Terre.",
content: "Due to its narrow winding paths flanked by a drop on one side and steep ascent/descent along an unpaved rocky wavy, the Vernazza-Monterosso hike is one of the toughest hikes in Cinque Terre.\nThis 2-hour walk is a daunting journey along the northernmost trail of this region. Nevertheless, adventurers who are up for the challenge go up the hike in droves.\nIf you are attempting the trail, do make sure you have loads of water, a good pair of hiking shoes, and walking sticks with you before starting out.\nHikers on this route are handsomely rewarded with a spectacular variety of vegetation along the way, and Vernazza’s winding alleyways and a panoramic view of almost all of Cinque Terre’s villages make this taxing trail worth the trouble.",
stroke: "#44CCC2",
color: "soccorso",
visibility: false,
path: "M372.3,425c0,0,4.1-0.8,4.7-1.9c0.6-1.1,2.2-3.8,4.4-0.8c2.2,3,3.3,5.7,5.7,3.3c2.4-2.4-0.3-2.7,3.5,0.3c3.8,3,6.3,7.9,12.3,5.7c6-2.2,11.4-4.4,11.4-4.4l-0.6,3.8c0,0,9.5-0.3,7.9,1.9c-1.6,2.2-4.4,3.3,0,6.5c4.4,3.3,13.6,5.7,16.4,4.9c2.7-0.8,6.8-1.9,9.3,2.2c2.4,4.1,4.9,7.9,9.3,8.7c4.4,0.8,10.4-1.4,10.4-1.4s-0.3,3.8,1.1,5.7"
},
{
zoomPositionX: 470,
zoomPositionY: 390,
zoomDimensionX: 320,
zoomDimensionY: 320,
name: "Corniglia to Manarola Trail",
titolo: "Il sentiero di Corniglia Manarola",
class: "hiking",
rating: "Stair-climbing req.",
distance: "5.5",
miles: "3.4",
from: "corniglia",
to: "volastra",
poi: "Corniglia / Manarola via Volastra",
intro: "The trail <i>7a</i> from Corniglia to Manarola via the sleepy little town of Volastra is better known as &ldquo;Porcina&rdquo;. The beginning of the trail is tough thanks to a steep path of ascending steps.",
content: "The beginning of the trail is tough thanks to a steep path of ascending steps, and it is this very part of the hike that has it famed for being relatively difficult. However, once you’re through the toughest part of the journey, a panoramic view of Corniglia greets you at multiple points along the way before you reach the Sanctuary of Volastra flanked by wine growing stone terraces. From there, a 30-minute hike via the small village of Groppo takes you towards the square which houses the beautiful church of San Lorenzo. A breathtaking panoramic view of Manarola from here is the perfect ending to this hike.",
update: "This trail has been closed for a long period now and is out of bounds for travellers since it is not safe.\nOnly the first 300 meters from the Manarola side is open for hiking.\nIt is set to reopen in 2021.",
stroke: "#D1993F",
color: "caribbean",
visibility: false,
path: "M556.1,517.4c0,0,5.7-5.7,6.8-7.4c1.1-1.7,0.7-2.8,3.3-3.5s7-4.4,8.9-5.7c1.8-1.3,7.2-4,7.2-4s-1.7,0.2-1.1,3.2c0.6,2.9,0.9,2.9,2.8,3.5s6.1,0.7,7.9,1.8c1.8,1.1,4.8,1.7,6.5,1.7s7.6-3.3,8.3-4c0.7-0.7,5-5.5,5-3.5s0.2-0.4-1.8,4.6c-2.1,5-5.9,8.3-5.4,10.7c0.6,2.4-2.4,3.2,2.1,3.2s9.6-2.8,9.8-0.4c0.2,2.4,0.6,9,2.2,11.5c1.7,2.4,3.2,3.9,6.1,3.9c2.9,0,7.8,0.2,7.8,0.2s-5,4.6,0,2.2c0.9,3.2,0.6,7.8,1.8,8.9c1.3,1.1,1.3,3.5,1.8,4.3c0.6,0.7,3.7,2.4,5.7,0.7c2.1-1.7-0.9-4.3,3.2-2.6c4,1.7,6.3,0,2.8,4.4c-3.5,4.44.8,5.5-7.8,8.5s-3.2,4-5,3.2c-1.8-0.9-1.3-5.9-3.7-3.7c-2.4,2.2-4.3,3.7-4.3,3.7l-9.6,6.7"
},
{
zoomPositionX: 512,
zoomPositionY: 486,
zoomDimensionX: 240,
zoomDimensionY: 240,
name: "Riomaggiore to Manarola Trail",
titolo: "Via dell&#x2019;Amore",
class: "hiking",
rating: "Easy",
distance: "1",
miles: "0.6",
from: "manarola",
to: "riomaggiore",
poi: "Riomaggiore Railway Station to Manarola Railway Station",
intro: "A 20 minute route from Riomaggiore to Manarola, the Via dell’Amore or ‘the Way of Love’ is a beautiful hiking trail along the coastline.",
content: "This twenty-minute romantic stroll along a flat, well-paved trail is undoubtedly the easiest of the Cinque Terre walking trails.\nThe romantic atmosphere of the rock-cut trail is attributed to a concoction of interlocked hearts over the entrance gate, lover sculptures, benches along the way and a little tunnel with ‘love graffiti’ on the walls towards the end.",
update: "This trail is temporarily inaccessible since it was damaged due to a heavy landslide in 2012. Due to the ongoing construction work, the main trail is closed and only a small part upto 200 meters from Manarola is accessible. It is expected to open by April 2021.",
stroke: "#9044CC",
color: "electric-lime",
visibility: false,
path: "M657.5,599.8c0,0,1.3-16.8,0.6-19.2c-0.7-2.4,0.9-4-0.4-5.2c-1.3-1.1-0.4-1.8-4.6-3.2c-4.3-1.3-5.4-1.7-6.8-2.9c-1.5-1.3-2.6-2.9-1.8-4c0.7-1.1,3.7-2.8-1.3-2.8s-4.6-0.7-7.8-0.7s-8.2,0.7-8.2,0.7l-9.8,7.4"
},
{
zoomPositionX: 512,
zoomPositionY: 486,
zoomDimensionX: 240,
zoomDimensionY: 240,
name: "Riomaggiore Ring Trail",
titolo: "L'anello Riomaggiore",
class: "hiking",
rating: "Easy",
distance: "3.5",
miles: "2.2",
from: "riomaggiore",
to: "riomaggiore",
poi: "From Riomaggiore to Riomaggiore",
intro: "The Riomaggiore Ring Trail comes about a full circle from Riomaggiore to Riomaggiore. This is one of the simplest hikes, even for novice hikers.",
content: "Although the hike can be undertaken in both clockwise and anticlockwise direction, it is advised to take the way up from the village parking and head in a clockwise direction towards the XI century parish church—the Sanctuary of Montenero. The church offers a spectacular display of beautiful offerings under an ornate ceiling. You also get to enjoy a breathtaking view of the sea coast from Montenero before you take the short trail down to Riomaggiore via a multitude of steps.\n",
update: "Due to a heavy landslide in 2012, this trail suffered extreme damages.\nIt is not accessible for hiking as of now since it is under going reconstruction.\nThe trail is expected to be ready and open to travellers by 2021.",
stroke: "#D23DA8",
color: "electric-lime",
visibility: false,
path: "M656.7,599.6c0,0,9.8,3.7,11.3,4.4c1.5,0.7,3.5,3.2,2.6,5.5c-0.9,2.4,1.3,4,3.2,2.9c1.8-1.1,7.9-4,12-5c4-0.9,10.2-1.8,12-4.8c1.8-2.9,1.1-4.3,3.9-4.3s6.1,0.7,6.1-1.5c0-2.2-0.7-2.8,1.3-4.3c2.1-1.5,2.8-2.8,2.8-2.8s-5.4-0.9-8.5,0.6c-3.2,1.5-5.9,1.7-8.5,1.7c-2.6,0-8.2-0.4-10,1.3c-1.8,1.7-4.3,1.7-8.5,1.3c-4.3-0.4-15.5-0.9-16.1-0.9c-0.6,0-2.5,1.8-2.8,2.6C657.2,597.3,656.7,599.6,656.7,599.6z"
},
{
zoomPositionX: 280,
zoomPositionY: 320,
zoomDimensionX: 420,
zoomDimensionY: 420,
name: "Blue Path Trail",
titolo: "Sentiero Azzurro",
class: "hiking",
rating: "Moderate",
distance: "12",
miles: "7.5",
from: "monterosso",
to: "riomaggiore",
poi: "Monterosso / Riomaggiore or the other way round",
intro: "The &ldquo;Sentiero Azzurro&rdquo; or the Blue Path Trail, spanning the length of all five villages, is the longest and the most renowned trails in the Cinque Terre.",
content: "The Blue Path Trail provides hikers with enough room to savor the trail as well as take in the rich heritage of the villages along the path. \nYou can head from Monterosso to Riomaggiore down south or the other way round, up north; however, first time hikers are recommended to commence from Riomaggiore and further move up so that they can choose to skip paths and hop onto trains as the difficulty level increases.\n",
update: "Due to a heavy landslide in 2012, this trail suffered extreme damages.\nIt is not accessible for hiking as of now since it is under going reconstruction.\nThe trail is expected to be ready and open to travellers by 2021.",
stroke: "#0E76CC",
color: "mexicano",
visibility: false,
path: "M372.3,425c0,0,4.1-0.8,4.7-1.9c0.6-1.1,2.2-3.8,4.4-0.8c2.2,3,3.3,5.7,5.7,3.3c2.4-2.4-0.3-2.7,3.5,0.3c3.8,3,6.3,7.9,12.3,5.7c6-2.2,11.4-4.4,11.4-4.4l-0.6,3.8c0,0,9.5-0.3,7.9,1.9c-1.6,2.2-4.4,3.3,0,6.5c4.4,3.3,13.6,5.7,16.4,4.9c2.7-0.8,6.8-1.9,9.3,2.2c2.4,4.1,4.9,7.9,9.3,8.7c4.4,0.8,10.4-1.4,10.4-1.4s-0.3,3.8,1.1,5.7c1.4,1.9,3.5,3.3,5.7,2.7s4,1.9,5.7,5.8c1.7,3.8,0.6,5.7,6,5.7c5.4,0,5.4,0,12.3,3c6.8,3,8.2,4.9,13.1,6.8c4.9,1.9,9.8,2.4,15,2.7s6.3,0.3,6.3,0.3s0.6-6,4.9-3c4.3,3,6.3,3.3,7.4,6.5c1.1,3.3,3.8,10.1,3.8,10.1l7.9,3.8l3.8,1.9l-6.3,6.6c0,0,1.4,0.6,2.8,1.1c1.4,0.6-1.1,4.7,2.4,3.8s5.2-1.2,13.3,0c8.9,1.3,10.6,2.3,18.5,7.2c7.9,4.9,10.7,5.9,17.7,13.7c5.5,6.1,7.4,14.8,7.4,14.8s-0.5,4.2-2.4,6.1c-1.9,1.9,3.2,4.6,3.2,4.6l1.1,5.4l0.9,1.3c0,0,5.8,0.8,6.7,1.8c0.8,1.1,2.9,2.6,6.2,4.8c3.3,2.2,7.1,3.1,7.1,5.5c0,2.4,0.8,3.7,3,3.7s4.2,0.3,4.2,0.3l2.9,2.4l1.8,3.5l6.3,7"
},
];

let terra = [
{
name: "elevation",
fill: "#D1F2D1",
stroke: "",
strokeWidth: "",
path: "M1024,1024H1.6c0,0,4.8-980.7,0-1024C-9.5-11.8,82.9,412.2,217.2,351.6c40.1-3.3-35.7,37.5,44.8,55.2c20.7-19,14.4,17.5,24.6-1.5c15.7-36.2,57.2-40.4,83.6-67.5c21.7-15.6,56.9-8,83.4-15.1c3,12.5-12.9,18.5-8.2,31.9c24.6,42.1-2.3,8.2-25.6,7.1c13,8-7.5,47.6,25.7,36.5c27-6.6,17.5-77.7,34.5-66.8c19.3,26.4,78.3,40.9,86.2,62.3c9.9,45.9-25.4,61.4,36.9,69.5c48.6,34.5,42.6-7.5,59.7,21.9c39.5,67.7,70.3,37.3,77.4,66.7c18.9,125.5,64.2,92.1,91,119.6c163.8,168.6,192.8,271.4,192.8,271.4L1024,1024zM756.9,544.7c11.7-4.3,24.9,3.1,34.6-8.8c2,0,6.1-2.6,3.4-5c-8.8-17.5-24.7-28.9-47.8-21C733.2,514.1,722.6,545.8,756.9,544.7z"
},
{
name: "sea",
fill: "#BCDFF7",
stroke: "",
strokeWidth: "",
path: "M1.6,1024V0c0,0,26.6,486.5,224.6,351.6c-42,28.6,2,40,33.6,69.3c7.2,29,38.5,37.4,56.3,60c13.4,15.1,16.8-41.4,27.8-45.9c3-1.8,7,3.3,8.1-1.8c3-15.4,9.4,0.3,28.8-8.1c9.9,5.3,0.9,5.8,18.4,8.7c10.9-4.1,15.6,2.8,24.4,8c5.5,4.9,14.5-1,21.1,5.5c9.1,15.5,14.4-0.5,25.8,16.8c10.1,15.7,3.2-2.4,30.8,21.5c50,0.6,26.1,22.1,41.5,31.1c0,7.2,13.4-2.4,35.9,2.7c15.6,8.7,36.9,19.1,33.7,38.2c-7.3,4.3,18.1,20.4,45.3,43.4c3.4,33.3-5.8,14.8,35.3,22.1c7.5,6.9,11.5-4.2,21.8-2.9c15.7,1.5-0.4,36.4,30.2,28.1c4.4,7.4,12.5,10,23.9,9.9c9.2,1.5,3.6,15.7,8.6,20.5c22.7-4.9,20.5,13,33.6,11.9c2.3-0.8,206,238.1,212.8,252.1c0.4,0.8,0.2,81.2,0.2,81.2H1.6z"
},
{
name: "shore",
fill: "",
stroke: "#ABCBDD",
strokeWidth: "2",
path: "M1.6,0c0,0,26.6,486.5,224.6,351.6c-42,28.6,2,40,33.6,69.3c7.2,29,38.5,37.4,56.3,60c13.4,15.1,16.8-41.4,27.8-45.9c3-1.8,7,3.3,8.1-1.8c3-15.4,9.4,0.3,28.8-8.1c9.9,5.3,0.9,5.8,18.4,8.7c10.9-4.1,15.6,2.8,24.4,8c5.5,4.9,14.5-1,21.1,5.5c9.1,15.5,14.4-0.5,25.8,16.8c10.1,15.7,3.2-2.4,30.8,21.5c50,0.6,26.1,22.1,41.5,31.1c0,7.2,13.4-2.4,35.9,2.7c15.6,8.7,36.9,19.1,33.7,38.2c-7.3,4.3,18.1,20.4,45.3,43.4c3.4,33.3-5.8,14.8,35.3,22.1c7.5,6.9,11.5-4.2,21.8-2.9c15.7,1.5-0.4,36.4,30.2,28.1c4.4,7.4,12.5,10,23.9,9.9c9.2,1.5,3.6,15.7,8.6,20.5c22.7-4.9,20.5,13,33.6,11.9c2.3-0.8,206,238.1,212.8,252.1"
}
];

/* spread operator `[...thing]` works with: `const thing = {my:"thing_one",}`, see: FrontEnd Masters, 4. Props */

let pointOfInterest = [
{
name: "monterosso",
x: "372",
y: "425",
anchor: "end"
},
{
name: "vernazza",
x: "470",
y: "463",
anchor: "end"
},
{
name: "corniglia",
x: "556",
y: "517",
anchor: "end"
},
{
name: "volastra",
x: "630",
y: "533",
anchor: "start"
},
{
name: "manarola",
x: "618",
y: "569",
anchor: "end"
},
{
name: "riomaggiore",
x: "658",
y: "600",
anchor: "end"
},
];
/* default: https://svelte.dev/examples#text-inputs `start`=left || `middle`=centred || `end`=right, see: https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/text-anchor */




// animate on scroll: https://www.youtube.com/watch?v=htrE84htqhM
let myfile = 'DEL.svg'; //https://stackoverflow.com/questions/56895865/how-to-use-local-static-images-in-svelte



let track = [
	{
		name: "loco",
		visibility: false,
	},
];

function loco() {
	track = [{visibility: true}]
}

let connections = [
{
zoomPositionX: 280,
zoomPositionY: 280,
zoomDimensionX: 420,
zoomDimensionY: 420,
name: "The return journey",
titolo: "Cinque Terre Passenger Train",
class: "",
rating: "Passive",
distance: "000",
miles: "000",
from: "riomaggiore",
to: "monterosso",
poi: "Riomaggiore to Monterosso return journey",
intro: "A stunning passenger train ride awaits your return journey across the beautiful coastline.",
content: "Content for the return journey.",
stroke: "",
color: "",
visibility: false,
path: "M656.8,599.4c-60.3-49.8-43-72.5-82.1-81.6c-3.5-1.3-5.5-3.1-9.1-5.7c-16-13.4-15.2-20.5-34.6-25.3 c-59.4-10.5-98.4-63-158.8-61.9"
},
];


</script>
<Icons />

<!-- <Banner bg="bg-petrol">
<img
class="w2 h2 white"
src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
style="background-image: url({myfile});"
alt={myfile}
>
<!-- <div class="ttu tracked-mega">Three</div> -- >
<!-- <div class="ttu tracked-mega">Four</div> -- >

<!-- <button
	class="dib pointer no-underline br0 f6 f5-ns f6-l b pv3 ph2 ph1-ns ph3-m pv2-l ph2-l ba bw2-ns bb b--black black bg-white grow ttu tracked tracked-mega-ns"
	class:test="{current === true}"
	on:click="{() => current = true}"
>Offerta speciale!</button> -- >
</Banner-->

<!-- <MotionList /> -->



<!--
It's also possible to apply a BG: `.myComponent {background-image: var(--firstSVG)}`
https://adactio.com/journal/15075 & https://css-tricks.com/change-color-of-svg-on-hover/
SVG as background URL `data`: https://www.sean-lloyd.com/post/adding-svg-background-inline-css/
-->




<!-- debug -->
<main
class="flex items-center
flex-column-reverse
flex-column-reverse-ns

flex-row-m
flex-row-l
">
<!-- vh-100 -->
<!--  //id="content" && Start left column: -->
<div class="
overflow-x-hidden
w-100 vh-50
w-50-ns vh-25-ns

w-two-thirds-m vh-100-m
w-50-l vh-100-l
">

<code
	use:viewport
	on:enterViewport={ () => {[
		$positionX = 256, $positionY = 256,
		$dimensionX = 512, $dimensionY = 512
	 ]} }
	style="color: cyan"
	class="f7 transparent"
	>
	<span class="b h6">ZOOM</span>
</code>

<!-- overflow-y-scroll -->

<!-- <TogglePortfolio /> -->

{#each destinations as destination }
<!-- {#each destinations as destination, i } `{i}`: -->
<!-- id={
	destination.from ? '#' + destination.from.toLowerCase().replace(/\s/g, '') : destination.name ? '#' + destination.name.toLowerCase().replace(/\s/g, '') : undefined
	} -->
<section
class="bg-white ma0">
<!-- id={destination.name} -->
<article
class="
mv0 ma4 measure lh-copy f4
ml1-ns
mr1-ns ml4-m mr4-m
ml5-l mr5-l"
>


<code
	id={destination.to}
	use:viewport
	on:enterViewport={ () => [
		destination.visibility = false,
		$positionX = destination.zoomPositionX,
		$positionY = destination.zoomPositionY,
		$dimensionX = destination.zoomDimensionX,
		$dimensionY = destination.zoomDimensionY
		]}
	on:exitViewport={ () => destination.visibility = false }
	style="color:{ destination.stroke }"
	class="f7 transparent"
	>
	<span class="b">ZOOM: </span> {@html destination.name }
</code>
<br>
<code
	id={destination.from}
	use:viewport
	on:enterViewport={ () => [
		destination.visibility = false
		]}
	on:exitViewport={ () => [
		destination.visibility = false,
		$positionX = destination.zoomPositionX,
		$positionY = destination.zoomPositionY,
		$dimensionX = destination.zoomDimensionX,
		$dimensionY = destination.zoomDimensionY
	]}
	style="color:{ destination.stroke }"
	class="f7 transparent"
><span class="b">UNDRAW: </span>{@html destination.name }
</code>


<header>

	<h1 class="tc tl-ns f2 fw7 ttu tracked lh-title mt0 mb3 avenir">
		{@html destination.name }
	</h1>
<code
	id={destination.to}
	use:viewport
	on:enterViewport={ () => [
		destination.visibility = false,
		$positionX = destination.zoomPositionX,
		$positionY = destination.zoomPositionY,
		$dimensionX = destination.zoomDimensionX,
		$dimensionY = destination.zoomDimensionY
	]}
	style="color:{ destination.stroke }"
	class="f7 transparent"
	>
	<span class="b">ZOOM: </span> {@html destination.name }
</code>

	{#if destination.titolo ? destination.titolo : undefined }
	<h2 class="tc tl-ns f3 fw4 i lh-title mt0 baskerville gray">
		{@html destination.titolo }
	</h2>
	{/if}

	<h3 class="w-90 mt0 gray f6 pb3 fw4">

		{#if destination.from ? destination.from : undefined }
			<span class="ttu tracked">{@html destination.from }</span>
		{/if}

		{#if destination.to && destination.from ? destination.to && destination.from : undefined }
			to
		{/if}

		{#if destination.to ? destination.to : undefined }
			<span class="ttu tracked" >{@html destination.to }</span>
		{/if}



		{#if !destination.to && !destination.from ? undefined && undefined : undefined }
			<span class="ttu tracked">{@html destination.name }</span>
		{/if}


		{#if destination.distance ? destination.distance : undefined }
			{@html destination.distance + 'Km' }
		{/if}
		{#if destination.miles ? destination.miles : undefined }
			<span class="dib dib-nd dib-m dn-l">a. </span>
			<span class="dn dn-nd dn-m dib-l">approx. </span>
			{@html  destination.miles + ' miles' }
		{/if}
	</h3>

	{#if destination.class ? destination.class : undefined }
	<h4 class="w-100 flex items-start flex-row flex-column-m">
		<svg viewBox="0 0 124 124" class="h2 w2 mr2 gray" alt="{destination.class} Trip">
			<use
				xlink:href=#{ destination.class ? 'icon-' + destination.class : '' }
			></use>
		</svg>
		<span class="w-90 mt0 f5 pb3 b gray ttc">
			{ destination.class ? destination.class : '' }:
			<span class="normal black ttn">{@html destination.rating || '' }</span>
		</span>
	</h4>
	{/if}
</header><!-- /header -->



<!-- on:exitViewport={ () => reset() } -->
	{#if destination.update ? destination.update : undefined }
	<aside class="w-100 flex items-start flex-row flex-column-m bw1 ba b--black-10 bg-soccorso pt3 pa1 mb4">
			<svg viewBox="0 0 124 124" class="h2 w2 mr2 white-80" alt="{'Warning about ' + destination.name }">
				<use
					xlink:href=#{ destination.update ? "icon-warning" : undefined }
				></use>
			</svg>

			<h5 class="w-90 mt0 f5">
				<span class="b white-80">{ destination.update ? 'Update:' : undefined }</span>
				{@html destination.update || '' }
			</h5>
		</aside>
	{/if}

<!--
--Note: Remember: named functions are more readable: https://youtu.be/ogXETl_I0Dg?t=2848
-->

<section class="pb4">{@html destination.intro || undefined }</section>
	{#if destination.content ? destination.content : undefined }
	<section class="pb3 pb3-ns pb3-m pb6-l">
		<h3>About this trail</h3>
		{@html destination.content }
	</section>
	{/if}

<!-- { destination.update ? renderMyThing : doNothing } -->
<!--
	class="{ destination.color } sr-only"
	Interpolate values; https://stackoverflow.com/questions/11849654/interpolate-or-tween-between-two-values-but-not-animating -->

<code
	id={destination.to}
	use:viewport
	on:enterViewport={ () => [
		$positionX = destination.zoomPositionX,
		$positionY = destination.zoomPositionY,
		$dimensionX = destination.zoomDimensionX,
		$dimensionY = destination.zoomDimensionY
	]}
	style="color:{ destination.stroke }"
	class="f7 transparent"
	>
	<span class="b">ZOOM: </span> {@html destination.name }
</code>
<code
	use:viewport
	on:enterViewport={ () => [
		destination.visibility = true,
		$positionX = destination.zoomPositionX,
		$positionY = destination.zoomPositionY,
		$dimensionX = destination.zoomDimensionX,
		$dimensionY = destination.zoomDimensionY
	]}
	style="color:{ destination.stroke }"
	class="f7 transparent"
><span class="b">DRAW: </span>{@html destination.name }
</code>
<hr class="bn pv3 pv3-ns pv5-m pv7-l">
<code
use:viewport
on:exitViewport={ () => [
	$positionX = destination.zoomPositionX,
	$positionY = destination.zoomPositionY,
	$dimensionX = destination.zoomDimensionX,
	$dimensionY = destination.zoomDimensionY
]}
	on:enterViewport={ () => [
		$positionX = destination.zoomPositionX,
		$positionY = destination.zoomPositionY,
		$dimensionX = destination.zoomDimensionX,
		$dimensionY = destination.zoomDimensionY
	]}
	style="color:{ destination.stroke }"
	class="f7 transparent"
	><span class="b">DRAW: </span>{@html destination.name }
</code>
</article><!-- /#intro -->
</section>

{/each}


















{#each connections as connection }

<section
class="bg-white ma0">

<article
class="
mv0 ma4 measure lh-copy f4
ml1-ns
mr1-ns ml4-m mr4-m
ml5-l mr5-l"
>

<code
	id={connection.to}
	use:viewport
	on:enterViewport={ () => [
		connection.visibility = false,
		$positionX = connection.zoomPositionX,
		$positionY = connection.zoomPositionY,
		$dimensionX = connection.zoomDimensionX,
		$dimensionY = connection.zoomDimensionY
		]}
	on:exitViewport={ () => connection.visibility = false }
	style="color:{ connection.stroke }"
	class="f7 transparent"
	>
	<span class="b">ZOOM: </span> {@html connection.name }
</code>
<br>
<code
	id={connection.from}
	use:viewport
	on:enterViewport={ () => [
		connection.visibility = false
		]}
	on:exitViewport={ () => [
		connection.visibility = false,
		$positionX = connection.zoomPositionX,
		$positionY = connection.zoomPositionY,
		$dimensionX = connection.zoomDimensionX,
		$dimensionY = connection.zoomDimensionY
	]}
	style="color:{ connection.stroke }"
	class="f7 transparent"
><span class="b">UNDRAW: </span>{@html connection.name }
</code>

<header>
	<h1 class="tc tl-ns f2 fw7 ttu tracked lh-title mt0 mb3 avenir">
		{@html connection.name }
	</h1>
<code
	id={connection.to}
	use:viewport
	on:enterViewport={ () => [
		connection.visibility = false,
		$positionX = connection.zoomPositionX,
		$positionY = connection.zoomPositionY,
		$dimensionX = connection.zoomDimensionX,
		$dimensionY = connection.zoomDimensionY
	]}
	style="color:{ connection.stroke }"
	class="f7 transparent"
	>
	<span class="b">ZOOM: </span> {@html connection.name }
</code>

	{#if connection.titolo ? connection.titolo : undefined }
	<h2 class="tc tl-ns f3 fw4 i lh-title mt0 baskerville gray">
		{@html connection.titolo }
	</h2>
	{/if}

	<h3 class="w-90 mt0 gray f6 pb3 fw4">

		{#if connection.from ? connection.from : undefined }
			<span class="ttu tracked">{@html connection.from }</span>
		{/if}

		{#if connection.to && connection.from ? connection.to && connection.from : undefined }
			to
		{/if}

		{#if connection.to ? connection.to : undefined }
			<span class="ttu tracked" >{@html connection.to }</span>
		{/if}


		{#if !connection.to && !connection.from ? undefined && undefined : undefined }
			<span class="ttu tracked">{@html connection.name }</span>
		{/if}


		{#if connection.distance ? connection.distance : undefined }
			{@html connection.distance + 'Km' }
		{/if}
		{#if connection.miles ? connection.miles : undefined }
			<span class="dib dib-nd dib-m dn-l">a. </span>
			<span class="dn dn-nd dn-m dib-l">approx. </span>
			{@html  connection.miles + ' miles' }
		{/if}
	</h3>

	{#if connection.class ? connection.class : undefined }
	<h4 class="w-100 flex items-start flex-row flex-column-m">
		<svg viewBox="0 0 124 124" class="h2 w2 mr2 gray" alt="{connection.class} Trip">
			<use
				xlink:href=#{ connection.class ? 'icon-' + connection.class : '' }
			></use>
		</svg>
		<span class="w-90 mt0 f5 pb3 b gray ttc">
			{ connection.class ? connection.class : '' }:
			<span class="normal black ttn">{@html connection.rating || '' }</span>
		</span>
	</h4>
	{/if}
</header><!-- /header -->



	{#if connection.update ? connection.update : undefined }
	<aside class="w-100 flex items-start flex-row flex-column-m bw1 ba b--black-10 bg-soccorso pt3 pa1 mb4">
			<svg viewBox="0 0 124 124" class="h2 w2 mr2 white-80" alt="{'Warning about ' + connection.name }">
				<use
					xlink:href=#{ connection.update ? "icon-warning" : undefined }
				></use>
			</svg>

			<h5 class="w-90 mt0 f5">
				<span class="b white-80">{ connection.update ? 'Update:' : undefined }</span>
				{@html connection.update || '' }
			</h5>
		</aside>
	{/if}


<section class="pb4">{@html connection.intro || undefined }</section>
	{#if connection.content ? connection.content : undefined }
	<section class="pb3 pb3-ns pb3-m pb6-l">
		<h3>About this trail</h3>
		{@html connection.content }
	</section>
	{/if}


<code
	id={connection.to}
	use:viewport
	on:enterViewport={ () => [
		$positionX = connection.zoomPositionX,
		$positionY = connection.zoomPositionY,
		$dimensionX = connection.zoomDimensionX,
		$dimensionY = connection.zoomDimensionY
	]}
	style="color:{ connection.stroke }"
	class="f7 transparent"
	>
	<span class="b">ZOOM: </span> {@html connection.name }
</code>
<code
	use:viewport
	on:enterViewport={ () => [
		connection.visibility = true,
		$positionX = connection.zoomPositionX,
		$positionY = connection.zoomPositionY,
		$dimensionX = connection.zoomDimensionX,
		$dimensionY = connection.zoomDimensionY
	]}
	style="color:{ connection.stroke }"
	class="f7 transparent"
><span class="b">DRAW: </span>{@html connection.name }
</code>


<!-- debug: the path to be animated along. RM `opacity="0"` -->
<code
	use:viewport
	on:exitViewport={ () => {track = [{visibility: false}]} }
	on:enterViewport={ () => loco() }
	style="color:transparent"
	class="f7"
><span class="b">TRAIN</code>
<!-- debug: the path to be animated along. RM `opacity="0"` -->



<hr class="bn pv3 pv3-ns pv5-m pv7-l">
<code
use:viewport
on:exitViewport={ () => [
	$positionX = connection.zoomPositionX,
	$positionY = connection.zoomPositionY,
	$dimensionX = connection.zoomDimensionX,
	$dimensionY = connection.zoomDimensionY
]}
	on:enterViewport={ () => [
		$positionX = connection.zoomPositionX,
		$positionY = connection.zoomPositionY,
		$dimensionX = connection.zoomDimensionX,
		$dimensionY = connection.zoomDimensionY
	]}
	style="color:{ connection.stroke }"
	class="f7 transparent"
	><span class="b">DRAW: </span>{@html connection.name }
</code>
</article><!-- /#intro -->
</section>

{/each}

<!-- /****** E N D *******/ -->
<code
use:viewport
on:enterViewport={ () => reset() }
><!-- class="bg-gold" --></code>
<!-- /****** E N D *******/ -->

<!-- <a href="#top">top</a> -->
</div><!-- /left column -->

<!-- Start: right column -->
<!-- bind:trigger -->
<Terre
	bg="#D7F9E1"
	bind:terra
	bind:pointOfInterest
	bind:destinations
	bind:connections
	bind:track
/><!-- /right column -->
</main><!-- /#content -->



<!--script>
/* `import AnimateLine from './AnimateLine.svelte';` */
let destinations = [
	{
		name: "destination_one",
		path: "M189.9,87.2c-2.2,0.3,191.2,67,84.2,213.5",
		color: "mexicano",
		visibility: 1
	},
	{
		name: "destination_two",
		path: "M274.1,300.7C398.8,284.7,390,480,312,521.5",
		color: "soccorso",
		visibility: 1
	},
	{
		name: "destination_three",
		path: "M312,521.5c123.1,40.3,93.4,156.7,36.5,191.5",
		color: "caribbean",
		visibility: 1
	},
	{
		name: "destination_four",
		path: "M348.5,713c68-6.1,63.4,58.5,9.8,92.7",
		color: "electric-lime",
		visibility: 1
	},
	{
		name: "destination_five",
		path: "M358.3,805.7c50-37.8,105.2,5.1,102.5,67.1",
		color: "grape",
		visibility: 1
	},

];
/* AnimateLine.svelte */
</script-->
<!-- <IpsumWars  start={'IpsumWars5'} end={'It crumbled'} /> -->
<!-- <script>
{#each pointOfInterest as poi }
<Section >

{poi.name.toLowerCase().replace(/\s/g, '')}<br>
<IpsumWars  start={'IpsumWars5'} end={'what a JEDI'} />

</Section>
{/each}
</script>

<ul>
{#each menu as {title, link, prefetch} }
<li>
{#if prefetch}
	<a rel="prefetch" href="{link}">{title}</a>
{:else}
	<a href="{link}">{title}</a>
{/if}
</li>
{/each}
</ul>
-->



<!-- <h1 use:viewport
	on:enterViewport={() => console.log('Foo Bar Baz, entered!')}
	on:exitViewport={() => console.log('Foo Bar Baz, left the building!')}
>Foo Bar Baz</h1> -->
<!-- Attaching event listener in Svelte: https://www.youtube.com/watch?v=_IGEl4t1TSM -->
<!--script>
/*
<span
use:viewport
class="bg-grape"
on:enterViewport="{() => current = 'foo'}"
>FOO trigger</span>


<code
	use:viewport
	on:enterViewport={() => destinations[1].visibility = true}
	class="bg-soccorso"
>destination_two</code>




<code
	use:viewport
	on:enterViewport={() => destinations[2].visibility = true}
	class="bg-caribbean"
>destination_three</code>

<span
use:viewport
class="bg-grape"
on:enterViewport="{() => current = 'bar'}"
>BAR trigger</span>

<IpsumWars  start={'what a JEDI'} end={ 'Ahsoka apprentice'} />

<code
use:viewport
on:enterViewport={() => destinations[3].visibility = true}
class="bg-electric-lime"
>destination_four</code>

<hr class="w-100 w-50-ns ma0 bn pt5 bg-meadow">

<Intersect />

<hr class="w-100 w-50-ns ma0 bn pt5 bg-raspberry">
<span
use:viewport
class="bg-grape"
on:enterViewport="{() => current = 'baz'}"
>BAZ trigger</span>

<code
use:viewport
on:enterViewport={() => destinations[4].visibility = true}
class="bg-raspberry"
>destination_five</code>
*/
</script-->




<style>
:global(body),
:global(html) {
  overflow-y: scroll;
  scroll-behavior: smooth;
	/* BIG REWRITE?: https://codepen.io/matthiasott/pen/GRoXqMQ */
	/* - from: https://codepen.io/diyifang/pen/MmQyoQ */
}
/* svg { viewBox: 256 256 512 512 }/* x */
.test {
transform:perspective(1px) scale(1.05);
background-color:red;
}
/* Visually hidden: https://css-tricks.com/inclusively-hidden/ */
.sr-only:not(:focus):not(:active) {
clip: rect(0 0 0 0);
clip-path: inset(50%);
height: 1px;
overflow: hidden;
position: absolute;
white-space: nowrap;
width: 1px;
}
.transparent {
color: transparent!important;
}
</style>